import { z } from 'zod'
import { type QuickMdState } from '@/app/store'
import { useAppSelector } from '@/redux/hooks/useAppSelector'
import { profilePermissions } from '@/utils/constants'

/**
 * The logged-in admin's profile (`GET /api/v1/profile`) is stored untyped in the
 * legacy Redux slice, so we narrow the only field we care about at the boundary.
 */
const ProfilePermissionsSchema = z.object({
  Permissions: z.array(z.string()).nullish(),
})

const selectAdminProfile = (state: QuickMdState) => state.accountSettings.adminProfile

/**
 * True when the logged-in admin holds `prescription.encounter.create` — the permission
 * the backend requires to open a prescription encounter (`GET /visits/{visitId}/encounterUrl`
 * returns 403 Permission otherwise). This gates the UI affordance so a staff member without
 * it never sees the add-prescription action.
 */
export function useCanCreatePrescriptionEncounter(): boolean {
  const adminProfile = useAppSelector(selectAdminProfile)
  const result = ProfilePermissionsSchema.safeParse(adminProfile)
  if (!result.success) return false
  return result.data.Permissions?.includes(profilePermissions.CREATE_PRESCRIPTION_ENCOUNTER) ?? false
}
